import type { Enums } from "../types";

/**
 * This function returns the color associated with a given assignment calculation type.
 * @param type
 * @returns
 */
export function getCalculationTypeColor(type: Enums<"assignmentCalculationType">): Enums<"color"> {
	switch (type) {
		case "hourly":
			return "emerald";
		case "service":
			return "blue";
	}
}
